import {ApexOptions} from 'apexcharts';
import {round} from 'lodash';
import {DashboardDto, Totals} from '../../../../../../shared/types/api-v2.types';

const getYearData = (totals?: Totals) => {
  const yearMap = new Map<number, number>();

  totals?.lastStatuses?.forEach((status) => {
    if (status.year) {
      yearMap.set(status.year, (yearMap.get(status.year) ?? 0) + (status?.count ?? 0));
    }
  });

  const sortedYears = Array.from(yearMap.keys()).sort((a, b) => b - a);

  if (sortedYears.length === 0) {
    return {
      labels: [],
      data: [],
    };
  }

  const labels = sortedYears.map((year) => year.toString());
  const data = sortedYears.map((year) => yearMap.get(year) || 0);

  return {labels, data};
};

export const preparePrimaryChartData = (
  contracts?: DashboardDto,
): {options: ApexOptions; series: ApexAxisChartSeries} => {
  const {data, labels} = getYearData(contracts?.totals);

  return {
    options: {
      chart: {toolbar: {show: false}},
      colors: [
        '#FF5E5E',
        '#3AC877',
        '#FF5E5E',
        '#3AC877',
        '#FF5E5E',
        '#3AC877',
        '#FF5E5E',
        '#3AC877',
        '#FF5E5E',
        '#3AC877',
        '#FF5E5E',
        '#3AC877',
      ],
      plotOptions: {bar: {distributed: true}},
      dataLabels: {enabled: false},
      legend: {show: false},
      tooltip: {
        shared: true,
        intersect: false,
        y: {formatter: (val: number) => `${val} заявок`},
      },
      xaxis: {
        labels: {style: {fontSize: '10px', colors: '#A3A3A3'}},
        categories: labels,
      },
      yaxis: {
        labels: {style: {fontSize: '12px', colors: '#A3A3A3'}},
      },
    },
    series: [{name: 'Количество заявок', data}],
  };
};

export const prepareSecondaryChartData = (
  dashboard?: DashboardDto,
): {options: ApexOptions; series: ApexAxisChartSeries} => {
  const leadTimes = dashboard?.totals?.leadTimes;

  const average = round(leadTimes?.average || 0, 0);
  const maximum = round(leadTimes?.max || 0, 0);
  const minimum = round(leadTimes?.min || 0, 0);

  const data = [average, maximum, minimum];

  return {
    options: {
      chart: {toolbar: {show: false}, type: 'bar'},
      plotOptions: {bar: {horizontal: true, distributed: true, barHeight: 10}},
      colors: ['#0D99FF'],
      dataLabels: {enabled: false},
      legend: {show: false},
      tooltip: {
        y: {formatter: (val: number) => `${val} дней`},
      },
      grid: {show: true, xaxis: {lines: {show: true}}, yaxis: {lines: {show: false}}},
      yaxis: {labels: {style: {fontSize: '12px', colors: '#464255'}}},
      xaxis: {
        min: 0,
        max: Math.max(20, maximum),
        categories: ['Среднее', 'Максимальное', 'Минимальное'],
        tickAmount: 10,
        labels: {style: {fontSize: '10px', colors: '#000'}},
      },
    },
    series: [{name: 'Время закрытия', data}],
  };
};
